const ko = {
  // Navbar
  'nav.home': '홈',
  'nav.services': '서비스',
  'nav.portfolio': '포트폴리오',
  'nav.about': '회사 소개',
  'nav.why': 'FMA를 선택하는 이유',
  'nav.faq': '자주 묻는 질문',
  'nav.contact': '문의하기',
  'nav.cta': '무료 견적 받기',

  // Portfolio Hero
  'portfolio.hero.title': '시공 포트폴리오',
  'portfolio.hero.titleEm': '& 사례',

  // Hero
  'hero.brand': 'Facility Maintenance of America',
  'hero.servingArea': '애틀란타 광역권 전 지역 서비스 중',
  'hero.panel1.tag': '다세대·아파트 전문 관리',
  'hero.panel1.title': '다세대 주택 &\n아파트 유지보수',
  'hero.panel1.subtitle': '고객의 아파트 커뮤니티, 저희가 책임집니다',
  'hero.panel1.desc': '유닛 턴오버부터 공용 구역 관리, 외벽 보수, 구조 수리까지 — FMA Crew는 애틀란타 광역권 아파트 커뮤니티와 다세대 주거 시설의 전문 유지보수 파트너입니다.',
  'hero.panel1.feat1': '유닛 턴오버 & 메이크레디',
  'hero.panel1.feat2': '공용 구역 관리',
  'hero.panel1.feat3': '외벽·파사드 관리',
  'hero.panel1.feat4': '면허 취득 전문가',
  'hero.panel1.cta': '서비스 보기',
  'hero.panel2.tag': '인테리어 리모델링',
  'hero.panel2.title': '주거·상업 공간\n리모델링',
  'hero.panel2.subtitle': '기획부터 완공까지 한 팀이 책임집니다',
  'hero.panel2.desc': '주방·욕실 리모델링부터 전체 공간 리노베이션까지 — 허가, 시공, 마감의 모든 과정을 함께합니다.',
  'hero.panel2.feat1': '주방 & 욕실',
  'hero.panel2.feat2': '인테리어 개조',
  'hero.panel2.feat3': '상업 공간 공사',
  'hero.panel2.feat4': '전체 리모델링',
  'hero.panel2.cta': '견적 문의',

  // Services
  'svc.label': '서비스 안내',
  'svc.heading': '저희가 하는',
  'svc.headingEm': '일',
  'svc.desc': '아파트 및 다세대 주거 시설 전문 유지보수부터 주거·상업 리모델링까지 — 시설 관리의 모든 것을 한 팀에서 해결하세요.',
  'svc.cat1.name': '다세대·아파트 유지보수',
  'svc.cat1.desc': '아파트 커뮤니티와 다세대 주거 시설을 위한 종합 유지보수 서비스 — 연중무휴로 건물의 안전, 미관, 입주 준비 상태를 유지합니다.',
  'svc.cat1.svc1': '유닛 턴오버 & 메이크레디',
  'svc.cat1.svc2': '공용 구역 관리 및 유지보수',
  'svc.cat1.svc3': '외벽·파사드 보수',
  'svc.cat1.svc4': '방수 및 구조 보수',
  'svc.cat1.svc5': '발코니·계단 복원',
  'svc.cat1.svc6': '예방 유지보수 프로그램',
  'svc.cat2.name': '주거 리모델링',
  'svc.cat2.desc': '주방, 욕실부터 전체 홈 리노베이션까지 — 집을 완전히 새롭게 바꿔드립니다.',
  'svc.cat2.svc1': '주방·욕실 리모델링',
  'svc.cat2.svc2': '인테리어 리노베이션',
  'svc.cat2.svc3': '바닥재·타일 시공',
  'svc.cat2.svc4': '도장 및 마감',
  'svc.cat2.svc5': '지하실 마감',
  'svc.cat2.svc6': '공간 확장',
  'svc.cat3.name': '상업 리모델링',
  'svc.cat3.desc': '전문적인 시공과 임차인 개선으로 상업 공간을 한 단계 업그레이드합니다.',
  'svc.cat3.svc1': '사무실·소매점 공사',
  'svc.cat3.svc2': '임차인 개선 (TI)',
  'svc.cat3.svc3': 'ADA 규정 준수 공사',
  'svc.cat3.svc4': '구조 변경',
  'svc.cat3.svc5': '상업 도장',
  'svc.cat3.svc6': '화장실·휴게실 개선',
  'svc.cat4.name': '일반 유지보수',
  'svc.cat4.desc': '언제든 믿고 맡길 수 있는 정기·긴급 유지보수 서비스.',
  'svc.cat4.svc1': '배관 수리',
  'svc.cat4.svc2': '전기 작업',
  'svc.cat4.svc3': 'HVAC 유지보수',
  'svc.cat4.svc4': '목공·석고보드',
  'svc.cat4.svc5': '고압 세척',
  'svc.cat4.svc6': '조경 및 부지 관리',
  'svc.btnEstimate': '무료 견적 받기',
  'svc.btnPortfolio': '포트폴리오 보기',

  // About
  'about.label': 'FMA Crew 소개',
  'about.heading': '유지보수부터 리모델링까지,',
  'about.headingEm': '믿을 수 있는 파트너',
  'about.p1': 'FMA Crew — <strong>Facility Maintenance of America</strong> — 는 애틀란타 광역권을 중심으로 두 가지 핵심 역량을 갖춘 종합 건설·시설 관리 전문 회사입니다: 아파트 커뮤니티 전문 유지보수, 그리고 주거·상업 공간 전체 리모델링.',
  'about.p2': '유닛 턴오버와 메이크레디, 공용 구역 관리, 구조 보수, 예방 유지보수 프로그램부터 — 주방·욕실 리모델링, 인테리어 전체 리노베이션, 지하실 마감, 증축, 상업 공간 전체 공사, 임차인 개선(TI)까지 — 풍부한 경험을 갖춘 전문가 팀이 고객의 자산을 보호하고, 공간의 가치를 높이며, 모든 프로젝트에서 기대 이상의 결과를 만들어 드립니다.',
  'about.badge.title': 'Excellence First',
  'about.badge.label': '모든 건물에서 최고의 기준',
  'about.stat1.value': 'GA',
  'about.stat1.label': '조지아 주 면허·보험 완비',
  'about.stat2.value': '10+',
  'about.stat2.label': '팀 현장 경력',
  'about.stat3.value': 'A+',
  'about.stat3.label': '시공 품질 기준',
  'about.stat4.value': '24/7',
  'about.stat4.label': '긴급 대응',
  'about.svc1.title': '다세대·아파트 유지보수',
  'about.svc1.desc': '유닛 턴오버, 공용 구역, 외벽 보수, 방수 & 예방 유지보수 — 아파트 커뮤니티를 안전하고 입주 준비된 상태로 유지합니다.',
  'about.svc2.title': '주거·상업 리모델링',
  'about.svc2.desc': '주방·욕실 리모델링, 인테리어 리노베이션, 지하실 마감, 증축, 상업 공간 전체 공사까지 — 허가부터 마감까지 한 팀이 끝까지 책임집니다.',

  // Why Choose Us
  'why.label': '선택 이유',
  'why.heading': 'FMA Crew가',
  'why.headingEm': '다른 점',
  'why.desc': '전문성, 투명한 소통, 그리고 저희가 담당하는 모든 아파트 커뮤니티와 부동산에 대한 진정한 관심으로 결과를 증명합니다.',
  'why.item1.title': '면허 취득 · 보험 완비',
  'why.item1.desc': '조지아 주 면허를 보유한 정식 업체로 모든 아파트 및 다세대 현장에 종합 책임보험이 적용됩니다.',
  'why.item2.title': '일정 & 예산 100% 준수',
  'why.item2.desc': '임대 일정과 입주민 약속을 소중히 생각합니다. 모든 유닛 턴오버와 프로젝트는 기간 내, 예산 안에서 반드시 완료합니다.',
  'why.item3.title': '전담 담당자 배정',
  'why.item3.desc': '모든 고객에게 전담 담당자를 배정해 건물 관리자가 언제든 직접 소통할 수 있도록 합니다.',
  'why.item4.title': '지역 전문가',
  'why.item4.desc': '애틀란타 아파트 시장에 깊이 뿌리를 둔 팀으로 지역 규정, HOA 요구사항, 협력사 네트워크를 누구보다 잘 압니다.',
  'why.item5.title': '원스톱 서비스',
  'why.item5.desc': '유닛 턴오버, 구조 보수, 공용 구역 업그레이드, 전체 리모델링까지 — 아파트 커뮤니티를 위한 여러 업체를 따로 관리할 필요가 없습니다.',
  'why.item6.title': '시공 품질 보증',
  'why.item6.desc': '모든 작업에 시공 보증을 제공합니다. 저희가 담당하는 모든 아파트 커뮤니티는 최고의 내부 기준으로 진행되며, 결과가 그 기준을 반영할 때까지 멈추지 않습니다.',

  // Testimonials
  'testi.label': '고객 후기',
  'testi.heading': '고객이 직접 말하는 FMA Crew',
  'testi.desc': '인테리어 도장, 홈 리노베이션, 일상 수리를 FMA Crew에 맡긴 애틀란타 광역권 주거·상업 고객들의 실제 후기입니다.',
  'testi.item1.name': 'Marcus D.',
  'testi.item1.role': '주택 소유자 · Smyrna, GA',
  'testi.item1.text': 'FMA Crew가 12개 실 전체의 인테리어 도장을 맡아주었습니다 — 천장, 벽, 몰딩, 문 전부요. 도장 전 균열 메우기, 샌딩, 프라이머 작업까지 꼼꼼하게 진행해 마감이 아주 매끄럽고 선명했습니다. 우리가 선택한 컬러 팔레트 그대로 완벽하게 구현되었고, 지금까지 경험한 인테리어 도장 중 단연 최고입니다.',
  'testi.item1.service': '인테리어 도장 & 마감',
  'testi.item2.name': 'Sandra R.',
  'testi.item2.role': '부동산 관리자 · Alpharetta, GA',
  'testi.item2.text': '아파트 커뮤니티 전체 유닛 턴오버를 FMA Crew에 맡기고 있습니다. 인테리어 도장, 석고보드 보수, 비품 교체, 메이크레디 체크리스트까지 모든 유닛을 일관되게, 일정에 맞춰, 높은 기준으로 처리해 줍니다. 파트너십 이후 공실 전환 기간이 눈에 띄게 줄었습니다.',
  'testi.item2.service': '유닛 턴오버 & 인테리어 수리',
  'testi.item3.name': 'Tony W.',
  'testi.item3.role': '주택 소유자 · Kennesaw, GA',
  'testi.item3.text': '주방 재배치, 욕실 리모델링, 전체 인테리어 도장, 원목 바닥재 재시공까지 홈 전면 리노베이션을 의뢰했습니다. 모든 공정을 직접 관리하며 매일 진행 상황을 공유해 주었고, 완전히 달라진 집을 완성해 주었습니다. 기대를 훨씬 뛰어넘는 시공 품질이었으며, 다음에도 반드시 다시 의뢰할 것입니다.',
  'testi.item3.service': '홈 리노베이션 & 리모델링',
  'testi.badge1.label': '면허 취득 · 보험 완비',
  'testi.badge1.sub': '조지아 주 정식 면허 보유',
  'testi.badge2.label': '애틀란타 광역권',
  'testi.badge2.sub': '서비스 중인 아파트 커뮤니티',
  'testi.badge3.label': '별점 5점',
  'testi.badge3.sub': '최고 품질 추구',

  // Contact
  'contact.label': '문의하기',
  'contact.hero.badge': '',
  'contact.hero.title': '무료 견적',
  'contact.hero.titleEm': '받기',
  'contact.hero.subtitle': '',
  'contact.heading': '무료 견적 받기',
  'contact.desc': '아파트 커뮤니티나 부동산에 대해 알려주시면 24시간 이내에 부담 없는 견적을 보내드립니다.',
  'contact.g1.title': '24시간 이내 답변',
  'contact.g1.desc': '모든 견적 요청은 영업일 기준 24시간 이내에 답변 드립니다. 약속드립니다.',
  'contact.g1.badge': '보장',
  'contact.g2.title': '완전 무료 견적',
  'contact.g2.desc': '비용 없이, 조건 없이 상세한 프로젝트 견적을 제공합니다.',
  'contact.g2.badge': '무료',
  'contact.g3.title': '면허 취득 · 보험 완비',
  'contact.g3.desc': '조지아 주 면허를 보유하고 보증·보험에 가입된 전문가들이 모든 작업을 진행합니다.',
  'contact.g3.badge': 'GA 면허',
  'contact.g4.title': '품질 최우선',
  'contact.g4.desc': '모든 견적, 모든 유닛 턴오버, 모든 아파트 커뮤니티 프로젝트에서 최고의 기준을 지킵니다.',
  'contact.g4.badge': '저희의 약속',
  'contact.info1.label': '전화번호',
  'contact.info2.label': '이메일',
  'contact.info3.label': '사무실 주소',
  'contact.info4.label': '운영 시간',
  'contact.info4.value': '월요일 – 금요일: 오전 9시 – 오후 5시\n토요일: 휴무\n일요일: 휴무',
  'contact.map.title': '서비스 지역',
  'contact.map.sub': '애틀란타 광역권 아파트 커뮤니티 및 주변 지역',
  'contact.map.active': '정상 운영 중',
  'contact.map.areasLabel': '서비스 가능 지역',
  'contact.form.title': '프로젝트 문의',
  'contact.form.sub': '아래 내용을 입력해 주시면 무료로 견적을 보내드립니다',
  'contact.form.badge': '24시간 이내 답변',
  'contact.form.badgeSub': '보장',
  'contact.form.firstName': '이름 *',
  'contact.form.firstPlaceholder': '길동',
  'contact.form.lastName': '성 *',
  'contact.form.lastPlaceholder': '홍',
  'contact.form.email': '이메일 주소 *',
  'contact.form.phone': '전화번호',
  'contact.form.service': '필요한 서비스 *',
  'contact.form.serviceDefault': '서비스를 선택해 주세요...',
  'contact.form.svc1': '다세대·아파트 유지보수',
  'contact.form.svc2': '유닛 턴오버 & 메이크레디',
  'contact.form.svc3': '주거 리모델링',
  'contact.form.svc4': '상업 리모델링',
  'contact.form.svc5': '일반 유지보수',
  'contact.form.svc6': '기타 / 일반 문의',
  'contact.form.property': '건물·커뮤니티 이름 & 주소',
  'contact.form.propertyPlaceholder': 'Sunset Apartments, 123 Main St, Atlanta, GA',
  'contact.form.message': '프로젝트 내용 *',
  'contact.form.messagePlaceholder': '아파트 커뮤니티, 세대 수, 유지보수 필요 사항, 일정, 특별 요청 사항 등을 자유롭게 입력해 주세요...',
  'contact.form.submit': '무료 견적 요청하기',
  'contact.form.submitting': '전송 중...',
  'contact.form.privacy': '입력하신 정보는 안전하게 보호되며 외부에 공유되지 않습니다. 24시간 이내에 연락드립니다.',
  'contact.form.success': '문의가 접수되었습니다! 24시간 이내에 연락드리겠습니다.',
  'contact.form.error': '오류가 발생했습니다. 470-222-5777로 직접 연락해 주세요.',

  // FAQ
  'faq.label': 'FAQ',
  'faq.hero.badge': '',
  'faq.hero.title': '자주 묻는',
  'faq.hero.titleEm': '질문',
  'faq.hero.subtitle': '',
  'faq.heading': '자주 묻는',
  'faq.headingEm': '질문',
  'faq.desc': '아파트 유지보수 서비스, 진행 과정, FMA Crew와 파트너십에 대해 자주 묻는 질문들을 모았습니다.',
  'faq.sidebar.questions': '개 질문',
  'faq.sidebar.stillHave': '더 궁금한 점이 있으신가요?',
  'faq.sidebar.stillHaveDesc': '여기서 다루지 않은 내용도 편하게 문의해 주세요. 팀이 직접 답변해 드립니다.',
  'faq.sidebar.call': '전화 문의',
  'faq.sidebar.email': '이메일 문의',
  'faq.sidebar.ready': '바로 시작하고 싶으신가요?',
  'faq.sidebar.readyDesc': '24시간 이내에 아파트 커뮤니티 무료 견적을 받아보세요.',
  'faq.sidebar.btn': '무료 견적 요청하기',
  'faq.sidebar.otherTopics': '다른 주제 보기',
  'faq.sidebar.browse': '',
  'faq.sidebar.commonQ': '개 자주 묻는 질문',
  'faq.sidebar.services': '',
  'faq.cat1.label': '다세대·아파트 유지보수',
  'faq.cat1.q1': '다세대·아파트 유지보수 서비스에는 어떤 항목이 포함되나요?',
  'faq.cat1.a1': '아파트 커뮤니티와 다세대 주거 시설에 필요한 전체 서비스를 제공합니다 — 유닛 턴오버 & 메이크레디, 공용 구역 관리(로비, 복도, 편의 시설), 외벽·파사드 보수, 발코니·계단 복원, 방수, 구조 보수, 건물 시스템 점검, 맞춤형 예방 유지보수 프로그램까지. 긴급 수리부터 정기 점검까지 건물을 항상 안전하고 입주 준비된 상태로 유지해 드립니다.',
  'faq.cat1.q2': '대규모 유닛 턴오버 & 메이크레디도 처리할 수 있나요?',
  'faq.cat1.a2': '네, 유닛 턴오버 관리는 저희의 핵심 강점 중 하나입니다. 다세대 메이크레디 일정을 조율해 공실 기간을 최소화하고 NOI를 극대화합니다. 도장, 청소 준비, 바닥재 보수, 비품 교체, 석고보드 보수, 전체 메이크레디 체크리스트를 모든 유닛에서 일관된 품질로 효율적으로 처리합니다.',
  'faq.cat1.q3': '긴급 아파트 보수 요청 시 얼마나 빨리 출동하나요?',
  'faq.cat1.a3': '기초 균열, 수분 침투, 외벽 손상 등 긴급 구조·안전 문제에 빠르게 대응합니다. 긴급 상황의 경우 보통 2~4시간 이내 현장 도착이 가능합니다. 즉시 상황을 파악해 안정화한 뒤 전체 보수 계획을 수립합니다. 입주민 안전과 만족이 최우선이라는 것을 저희도 같이 생각합니다.',
  'faq.cat1.q4': '아파트 커뮤니티를 위한 예방 유지보수 프로그램을 설계해 줄 수 있나요?',
  'faq.cat1.a4': '물론입니다. 아파트 커뮤니티에 특화된 맞춤형 예방 유지보수 일정을 설계합니다 — 월별·분기별·반기별로 구조 점검, 외벽·파사드 확인, 방수 평가, 발코니·계단 점검, 공용 구역 검토, 건물 시스템 점검을 포함합니다. 예방 프로그램을 통해 긴급 수리 비용을 크게 줄이고 자산 가치를 보호하며 입주민 만족도를 높일 수 있습니다.',
  'faq.cat1.q5': '부동산 관리 회사 및 HOA와 협업이 가능한가요?',
  'faq.cat1.a5': '네, 부동산 관리 회사, HOA, 아파트 소유 그룹과 정기적으로 파트너십을 맺고 있습니다. 관리 커뮤니티의 고유한 소통 및 보고 요건을 이해하고 있으며, 정기적인 진행 상황 업데이트, 사진 기록, 완료 보고서를 제공합니다. 필요한 경우 입주민과 직접 조율해 유지보수 및 보수 공사 중 불편을 최소화합니다.',
  'faq.cat2.label': '주거 리모델링',
  'faq.cat2.q1': '주방이나 욕실 리모델링은 보통 얼마나 걸리나요?',
  'faq.cat2.a1': '일반적인 주방 리모델링은 공사 범위, 맞춤 캐비닛 납기, 허가 승인 기간에 따라 6~12주 정도 소요됩니다. 욕실 리모델링은 보통 3~6주 진행됩니다. 착공 전 상세한 공정표를 제공해 각 단계에서 어떤 작업이 진행되는지 명확하게 알 수 있습니다.',
  'faq.cat2.q2': '허가 취득과 검사 일정도 대신 처리해 주나요?',
  'faq.cat2.a2': '네, 필요한 모든 허가를 직접 취득하고 검사 일정도 저희가 관리합니다. 시청이나 군청과 따로 연락하실 필요가 없습니다. 모든 작업은 관련 법규를 준수하고, 준공 전 검사까지 완료합니다.',
  'faq.cat2.q3': '제가 선택한 인테리어 디자이너나 건축사와 협업할 수 있나요?',
  'faq.cat2.a3': '물론입니다. 인테리어 디자이너, 건축사, 데코레이터와 자주 협업하고 있습니다. 이미 설계 도면이나 선호하는 디자이너가 있다면 자연스럽게 연결해 드립니다. 필요하시면 신뢰할 수 있는 지역 디자이너를 소개해 드릴 수도 있습니다.',
  'faq.cat2.q4': '공사비 납입 일정은 어떻게 되나요?',
  'faq.cat2.a4': '보통 계약 체결 시 착수금, 골조·배선 완료 시 중도금, 공사 완료 및 최종 확인 시 잔금의 3단계로 진행합니다. 공사 시작 전 대부분의 비용을 요구하지 않습니다.',
  'faq.cat2.q5': '리모델링 작업에 하자 보증이 있나요?',
  'faq.cat2.a5': '네, 모든 시공에 1년 하자 보증을 제공합니다. 사용된 자재는 준공 시 제조사 보증이 고객에게 이전됩니다. 보증 기간 내 문제가 발생하면 무상으로 처리해 드립니다.',
  'faq.cat3.label': '상업 리모델링',
  'faq.cat3.q1': '영업 시간 외 작업으로 업무 중단을 최소화할 수 있나요?',
  'faq.cat3.a1': '네, 비즈니스 운영에 지장이 없도록 야간·주말·단계적 작업 방식으로 진행합니다. 입주 건물의 임차인 개선 공사의 경우 건물주 및 인근 임차인과 직접 조율하여 불편을 최소화합니다.',
  'faq.cat3.q2': '임차인 개선(TI) 수당 프로젝트도 처리할 수 있나요?',
  'faq.cat3.a2': '네, TI 프로젝트 경험이 풍부합니다. 임대인·임차인과 직접 협력하여 수당 예산을 관리하고, 임대인 승인 요건을 조율하며, 임대 사양과 임차인 요구를 모두 충족하는 공사를 제공합니다.',
  'faq.cat3.q3': '어떤 종류의 상업 공간을 시공하나요?',
  'faq.cat3.a3': '사무실 및 전층 공사, 소매점·부티크, 레스토랑·카페, 의료·치과 사무실, 피트니스 스튜디오, 살롱, 경공업 공간 등 다양한 상업 공간을 시공합니다. 원하시는 공간 유형이 있다면 편하게 문의해 주세요.',
  'faq.cat3.q4': '건축법 및 ADA 규정 준수는 어떻게 보장하나요?',
  'faq.cat3.a4': '모든 프로젝트는 착공 전 지역 건축법 준수 여부를 검토합니다. ADA 기준을 완전히 숙지하고 있으며, 필요한 규정 준수 공사를 사전에 파악해 반영합니다. 모든 프로젝트는 해당 관할 기관에 의해 허가 및 검사가 진행됩니다.',
  'faq.cat3.q5': '상업 프로젝트는 얼마나 빨리 착공할 수 있나요?',
  'faq.cat3.a5': '대부분의 상업 프로젝트는 설계·계획 단계를 즉시 시작할 수 있으며, 허가 일정과 자재 조달에 따라 2~4주 내에 착공 가능합니다. 임대 시작일이나 개업 목표일에 맞춰 일정을 최우선으로 조율합니다.',
  'faq.cat4.label': '일반 유지보수',
  'faq.cat4.q1': '긴급 유지보수 서비스도 제공하나요?',
  'faq.cat4.a1': '네, 파이프 파열, 전기 위험, HVAC 고장, 지붕 누수 등 긴급 상황에 대한 응급 대응을 제공합니다. 긴급 라인은 24시간 운영되며, 실제 긴급 상황의 경우 위치에 따라 2~4시간 이내에 현장 도착합니다.',
  'faq.cat4.q2': '정기적인 예방 유지보수 계약을 맺을 수 있나요?',
  'faq.cat4.a2': '물론입니다. HVAC 필터 교체, 배관 점검, 외부 검사, 조명 등을 포함한 월별·분기별·반기별 방문의 맞춤형 유지보수 계약을 제공합니다. 예방 관리를 통해 장기적으로 긴급 수리 비용을 크게 절감할 수 있습니다.',
  'faq.cat4.q3': '유지보수 팀이 담당하는 분야는 어떻게 되나요?',
  'faq.cat4.a3': '사내 팀은 일반 목공, 석고보드, 도장, 기본 배관 및 전기를 직접 처리합니다. 전문 분야(면허 필요 배관·전기·HVAC·지붕)의 경우 검증된 면허 하청업체를 투입하며, 모든 조율은 저희가 직접 담당합니다.',
  'faq.cat4.q4': '주거 건물과 상업 건물 모두 서비스가 가능한가요?',
  'faq.cat4.a4': '네, 단독 주택, 타운홈, 콘도, 아파트 단지 등 주거 시설과 오피스 파크, 소매 센터, 레스토랑, 경공업 시설 등 상업 건물 모두 관리합니다. 각 유형의 특성과 요구사항에 맞는 풍부한 경험을 보유하고 있습니다.',
  'faq.cat4.q5': '유지보수 계약은 어떻게 시작하나요?',
  'faq.cat4.a5': '간단합니다. 무료 현장 방문 점검을 신청해 주시면 건물을 직접 둘러보고 필요 사항을 파악한 뒤 맞춤형 제안서를 드립니다. 승인 후 보통 1주일 이내에 시작할 수 있습니다. 장기 계약을 강요하지 않습니다 — 결과로 신뢰를 쌓겠습니다.',

  // Footer
  'footer.tagline': '다세대 주택 및 아파트 유지보수 전문 — 건물 건설·리모델링 종합 서비스로 애틀란타 광역권을 책임집니다.',
  'footer.svcHeading': '서비스',
  'footer.compHeading': '회사 정보',
  'footer.svc1': '다세대·아파트 유지보수',
  'footer.svc2': '주거 리모델링',
  'footer.svc3': '상업 리모델링',
  'footer.svc4': '일반 유지보수',
  'footer.link1': 'FMA Crew 소개',
  'footer.link2': '선택 이유',
  'footer.link3': '문의하기',
  'footer.link4': '무료 견적',
  'footer.newsletter.title': '소식 받아보기',
  'footer.newsletter.desc': '아파트 유지보수 팁, 다세대 부동산 관리 정보, 서비스 업데이트를 이메일로 받아보세요.',
  'footer.newsletter.placeholder': 'your@email.com',
  'footer.newsletter.btn': '구독하기',
  'footer.newsletter.success': '구독 완료! 감사합니다.',
  'footer.copy': '© 2026 FMA Crew — Facility Maintenance of America. All rights reserved.',
};

export default ko;
